// @flow

export const getCurrentStep = (): number => {
  const stepNode = document.querySelector('.enroll-step.active')
  let step = 1
  if (stepNode) {
    step = Number(stepNode.dataset.step) || 1
  }

  return step
}
